import { PropTypes } from "prop-types";
import React from "react";
import { MODULE_ID } from "../moduleIds";

const PatientItem = ({
  patient,
  patientIsActive,
  showPHI,
  specifics,
  isCustomBedList,
  module,
}) => {
  /** ************************************************ FUNCTIONS ************************************************ */

  const EMPTY_SPACERS = `, • •`;

  const pmInfo = () => {
    if (showPHI) {
      return `${patient.lastName}, ${patient.firstName} • ${
        patient?.gender ? patient.gender[0] : ""
      } • ${patient?.age ? patient?.age : ""}`;
    } else {
      return `${patient.lastName.slice(0, 3)}, ${patient.firstName.slice(
        0,
        3,
      )} • ${patient?.gender ? patient.gender[0] : ""} • ${
        patient?.age ? patient?.age : ""
      } `;
    }
  };

  const obInfo = () => {
    if (showPHI) {
      return `${patient.lastName}, ${patient.firstName} • ${
        patient?.age ? patient?.age : ""
      }`;
    } else {
      return `${patient.lastName.slice(0, 3)}, ${patient.firstName.slice(
        0,
        3,
      )} • ${patient?.age ? patient?.age : ""}`;
    }
  };

  const getPatientText = () => {
    if (patientIsActive || !isCustomBedList) {
      return module === MODULE_ID.OBSTETRICS ? obInfo() : pmInfo();
    } else {
      // AS1-5280 Product wants empty spacers to show if patient is inactive
      return EMPTY_SPACERS;
    }
  };

  const getLocationText = () => `${specifics?.unit} • ${specifics?.location}`;

  /** ************************************************* RENDER ************************************************** */

  return (
    <div className="patient-info">
      <div className="name" data-testid="PatientItem:patient-info:name">
        {getPatientText()}
      </div>
      <div className="location" data-testid="PatientItem:patient-info:location">
        {getLocationText()}
      </div>
    </div>
  );
};

PatientItem.propTypes = {
  patient: PropTypes.object,
  showPHI: PropTypes.bool,
  specifics: PropTypes.object,
};

export default PatientItem;
